// src/utils/axiosInstance.js
import axios from 'axios';
import { BASE_URL } from ".";

const axiosInstance = axios.create({
  baseURL: BASE_URL, // Base API URL
  timeout: 20000, // Set timeout
});

// Define routes that do not require a token
const routesWithoutToken = [
  '/purchase-point',
  '/purchase-point',
  '/register',
  '/login',
  '/logout',
  '/auth/google',
  '/api/verify',
  '/images',
  '/contract/contract-templates/access',
  '/contract-templates/pdfs/preview'
];

// Add interceptors
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    // Check if the request URL is in the list of routes that don't require a token
    const isRouteWithoutToken = routesWithoutToken.some((route) =>
      config.url.includes(route)
    );

    //console.log('config.url:', config.url);
    //console.log('!isRouteWithoutToken:', !isRouteWithoutToken);
    //console.log('token:', token);

    // If token is required and not available, throw an error to prevent the request
    if (!isRouteWithoutToken && !token) {
      console.warn('Token missing, request aborted:', config.url);
      return Promise.reject(new Error(`Token is required for ${config.url}`));
    }

    // If token is available, add it to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default axiosInstance;





